import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './header'
import Menu from './menu'
import EnglishCasinoHeader from './english_casino_header'
import GamesService from '../services/casinoGamesService'
import { staticContentsImagePath as BASE_IMAGE_PATH, OPERATOR_ID } from '../configs/const';
import '../css/casino/index.css'
import '../css/casino/style.css'
import '../css/casino/responsive.css'
import CasinoCurrencyModal from './sub_components/casinoCurrencyModal';
import { casinoCurrencyList } from '../configs/casinoCurrencyList';
import * as authUtil from "../util/auth.util";
let oid = OPERATOR_ID.toLowerCase()
class Spribe extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            games: [],
            allGames: [],
            showPopup: true,
            operator: OPERATOR_ID,
            gameType: "ALL",
            gameCategory: "All",
            gamePartner: "All",
            openGame: false,
            link: "",
            loader: false,
            isLiveCasino: false,
            c2partners: ["Spribe"]
        };
    }
    changeGameType(game_type) {
        let self = this
        this.setState({ gameType: game_type, loader: true, isLiveCasino: game_type === "LIVECASINO" ? true : false }, () => {
            self.filterParnterGameType(this.state.allGames)
        })
    }
    changeGamePartner(game_partner) {
        let self = this
        this.setState({ gamePartner: game_partner, loader: true, gameType: "ALL" }, () => {
            self.filterParnterGameType(this.state.allGames)
        })
    }
    // componentWillReceiveProps() {
    //     this.setState({ loader: true })
    //     setTimeout(() => {
    //         const self = this;
    //         const operator = this.state.operator
    //         let token = JSON.parse(localStorage.getItem('userAuthDetail'))
    //         token = token.token
    //         if (!!operator && !!token) {
    //             window.localStorage.setItem("operator", operator);
    //             window.localStorage.setItem("token", token);
    //             let gameType = "ALL"
    //             self.setState({ "operator": operator, gameType: gameType, isLiveCasino: gameType === "LIVECASINO" ? true : false }, () => {
    //                 window.setTimeout(function () {
    //                     self.loadGames();
    //                 }, 100);
    //             });
    //         }
    //     }, 100)
    // }
    componentDidMount() {
        let accData = JSON.parse(localStorage.getItem("accountData"));
        if ((!!accData && Object.keys(accData).length > 0)) {
            this.setState({ loader: true, showPopup: casinoCurrencyList["SPRIBE"].currencyEquals === '1' ? false : true })
            setTimeout(() => {
                const self = this;
                const operator = this.state.operator
                let token = JSON.parse(localStorage.getItem('userAuthDetail'))
                let rl = token?.role
                token = token.token
                if (!!operator && !!token && rl !== 'DemoClient') {
                    window.localStorage.setItem("operator", operator);
                    window.localStorage.setItem("token", token);
                    let gameType = "ALL"
                    self.setState({ "operator": operator, gameType: gameType, isLiveCasino: gameType === "LIVECASINO" ? true : false }, () => {
                        window.setTimeout(function () {
                            self.loadGames();
                        }, 100);
                    });
                }
            }, 100)
        }
    }
    loadGames = async () => {
        const operator = this.state.operator
        let token = JSON.parse(localStorage.getItem('userAuthDetail'))
        let rl = token?.role
        token = token.token
        if (!!operator && !!token && rl !== 'DemoClient') {
            window.setTimeout(function () {
                this.getSpribeGames();
            }.bind(this), 1500)
        }
    }
    getSpribeGames = () => {
        let self = this
        GamesService.getSPRIBEGames().then((res) => {
            // res.data = res.data.filter((elem, i) => {
            //     return elem.partner === "Spribe";
            // })
            // this.filterParnterGameType(res.data)
            this.setState({ games: res.data, isLoading: false, loader: false });
        }).catch((e) => { });
    }

    filterParnterGameType(data) {
        const gameType = this.state.gameType;
        const gamePartner = this.state.gamePartner;
        const gamesData = data;
        let games = [];
        if (gamePartner === "All") {
            if (gameType === "ALL") {
                // games = gamesData
                // let evolution = gamesData.filter((game) => game.partner === "Evolution Gaming");
                let ezugi = gamesData.filter((game) => game.partner === "Ezugi");
                let other_games = gamesData.filter((game) => game.partner !== "Ezugi" && game.partner !== "Evolution Gaming" && game.partner !== "eBET" && game.partner !== "SA Gaming" && game.partner !== "Asia Gaming" && game.partner !== "Betsoft" && game.partner !== "Super Spade Games" && game.partner !== "Kiron" && game.partner !== "Edge Gaming" && game.partner !== "Golden Race" && game.partner !== "Spadegaming" && game.partner !== "Spribe");
                let super_spead = gamesData.filter((game) => game.partner === "Super Spade Games" && (game.gameId.includes("2643") || game.gameId.includes("2648") || game.gameId.includes("2652") || game.gameId.includes("2659") || game.gameId.includes("2663") || game.gameId.includes("2667") || game.gameId.includes("6453") || game.gameId.includes("11548") || game.gameId.includes("11556") || game.gameId.includes("11564")))
                // games.concat(evolution)
                // games.concat(ezugi)
                // games.concat(other_games)
                games = [...ezugi, ...other_games, ...super_spead];
                // games.sort((a,b) => (a.category > b.category) ? 1 : ((b.category > a.category) ? -1 : 0))
            }
            else if (gameType === "new") {
                // games = gamesData.filter((game) => game.isNew);
                // let evolution = gamesData.filter((game) => game.isNew && game.partner === "Evolution Gaming");
                let ezugi = gamesData.filter((game) => game.isNew && game.partner === "Ezugi");
                let other_games = gamesData.filter((game) => game.partner !== "Ezugi" && game.partner !== "Evolution Gaming" && game.partner !== "eBET" && game.partner !== "SA Gaming" && game.partner !== "Asia Gaming" && game.partner !== "Betsoft" && game.partner !== "Super Spade Games" && game.partner !== "Kiron" && game.partner !== "Edge Gaming" && game.partner !== "Golden Race" && game.partner !== "Spadegaming" && game.partner !== "Spribe");
                let super_spead = gamesData.filter((game) => game.isNew && game.partner === "Super Spade Games" && (game.gameId.includes("2643") || game.gameId.includes("2648") || game.gameId.includes("2652") || game.gameId.includes("2659") || game.gameId.includes("2663") || game.gameId.includes("2667") || game.gameId.includes("6453") || game.gameId.includes("11548") || game.gameId.includes("11556") || game.gameId.includes("11564")))
                games = [...ezugi, ...other_games, ...super_spead];
            }
            else if (gameType === "hot") {
                // games = gamesData.filter((game) => game.isPopular);
                // let evolution = gamesData.filter((game) => game.isPopular && game.partner === "Evolution Gaming");
                let ezugi = gamesData.filter((game) => game.isPopular && game.partner === "Ezugi");
                let other_games = gamesData.filter((game) => game.partner !== "Ezugi" && game.partner !== "Evolution Gaming" && game.partner !== "eBET" && game.partner !== "SA Gaming" && game.partner !== "Asia Gaming" && game.partner !== "Betsoft" && game.partner !== "Super Spade Games" && game.partner !== "Kiron" && game.partner !== "Edge Gaming" && game.partner !== "Golden Race" && game.partner !== "Spadegaming" && game.partner !== "Spribe");
                let super_spead = gamesData.filter((game) => game.isPopular && game.partner === "Super Spade Games" && (game.gameId.includes("2643") || game.gameId.includes("2648") || game.gameId.includes("2652") || game.gameId.includes("2659") || game.gameId.includes("2663") || game.gameId.includes("2667") || game.gameId.includes("6453") || game.gameId.includes("11548") || game.gameId.includes("11556") || game.gameId.includes("11564")))
                games = [...ezugi, ...other_games, ...super_spead];
            }
            else {
                games = gamesData.filter((game) => game.category === gameType);
                // let evolution = gamesData.filter((game) => game.category === gameType && game.partner === "Evolution Gaming");
                let ezugi = gamesData.filter((game) => game.category === gameType && game.partner === "Ezugi");
                let other_games = gamesData.filter((game) => game.partner !== "Ezugi" && game.partner !== "Evolution Gaming" && game.partner !== "eBET" && game.partner !== "SA Gaming" && game.partner !== "Asia Gaming" && game.partner !== "Betsoft" && game.partner !== "Super Spade Games" && game.partner !== "Kiron" && game.partner !== "Edge Gaming" && game.partner !== "Golden Race" && game.partner !== "Spadegaming" && game.partner !== "Spribe");
                let super_spead = gamesData.filter((game) => game.category === gameType && game.partner === "Super Spade Games" && (game.gameId.includes("2643") || game.gameId.includes("2648") || game.gameId.includes("2652") || game.gameId.includes("2659") || game.gameId.includes("2663") || game.gameId.includes("2667") || game.gameId.includes("6453") || game.gameId.includes("11548") || game.gameId.includes("11556") || game.gameId.includes("11564")))
                games = [...ezugi, ...other_games, ...super_spead];
            }
        } else {
            if (gameType === "ALL" && gamePartner === "Super Spade Games") {
                games = gamesData.filter((game) => game.partner === "Super Spade Games" && (game.gameId.includes("2643") || game.gameId.includes("2648") || game.gameId.includes("2652") || game.gameId.includes("2659") || game.gameId.includes("2663") || game.gameId.includes("2667") || game.gameId.includes("6453") || game.gameId.includes("11548") || game.gameId.includes("11556") || game.gameId.includes("11564")))
            }
            else if (gamePartner === "Super Spade Games") {
                games = gamesData.filter((game) => game.category === gameType && game.partner === "Super Spade Games" && (game.gameId.includes("2643") || game.gameId.includes("2648") || game.gameId.includes("2652") || game.gameId.includes("2659") || game.gameId.includes("2663") || game.gameId.includes("2667") || game.gameId.includes("6453") || game.gameId.includes("11548") || game.gameId.includes("11556") || game.gameId.includes("11564")))
            }
            else if (gameType === "ALL") {
                games = gamesData.filter((game) => game.partner === gamePartner);
            }
            else if (gameType === "new") {
                games = gamesData.filter((game) => game.isNew && game.partner === gamePartner);
            }
            else if (gameType === "hot") {
                games = gamesData.filter((game) => game.isPopular && game.partner === gamePartner);
            }
            else {
                games = gamesData.filter((game) => game.category === gameType && game.partner === gamePartner);
            }
        }
        this.setState({ allGames: gamesData, games: games, isLoading: false, loader: false });
    }

    getIndividualGame = async (gameId) => {
        this.setState({ isLoading: true });
        const gameRes = await GamesService.getIndividualGame(gameId);
        const gameData = gameRes.data;
        if (!gameData && !gameRes.isSuccess && !!gameRes?.exception?.message) {
            this.props.MySwal.fire({
                title: 'Error',
                text: `${gameRes?.exception?.code} ${gameRes?.exception?.message}`,
                icon: 'error',
                confirmButtonText: 'OK',
            })
            this.setState({ loader: false });
            // this.setState({ popupMessage: gameRes.message });
        }
        if (!!gameData && !!gameData.url) {
            this.setState({ openGame: true, link: gameData.url })
        }
    }

    hideCurrencyPopup() {
        this.setState({ showPopup: false });
    }
    render() {
        let accData = JSON.parse(localStorage.getItem("accountData"));
        const profData = JSON.parse(localStorage.getItem("profData"));
        return (
            <body className="radheexch">
                <Header notify={this.props.notify} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} history={this.props.history} socket={this.props.socket} />
                <div className={`full-wrap mar-top100 footerpd ${(!!accData && Object.keys(accData).length > 0) ? '' : 'mar-top100-login mar-bottom0'}`}>
                    
                    <Menu history={this.props.history} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} />

                    { (!!profData && profData.role !== 'DemoClient') && (!!accData && Object.keys(accData).length > 0) ?
                        <div className="col-center1 markets">
                            <section>
                                <div className="sub_path center-box"><p>Casino</p></div>
                                <div className={`container-fluid casino-content-page ${this.state.operator}`} >
                                    {this.state.openGame !== true ? <>
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="loader-bg" style={{ display: this.state.isLoading ? "flex" : "none" }}>
                                                    <img alt="" src={BASE_IMAGE_PATH + "/" + oid + "/uimg/loader.gif"} className={`${this.state.isLoading ? "loader-image-active" : "loader-image-active"}`} />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-12">
                                                <div className="loader-bg" style={{ display: this.state.loader ? "flex" : "none" }}>
                                                    <img alt="" src={BASE_IMAGE_PATH + "/" + oid + "/uimg/loader.gif"} className={`${this.state.loader ? "loader-image-active" : "loader-image-active"}`} />
                                                </div>
                                            </div>
                                        </div>
                                        {!this.state.loader && !this.state.isLoading &&
                                            <div className="row">
                                                <div className="text-center mb-0">
                                                    <img alt="" src={BASE_IMAGE_PATH + "/casino/banner/aviator-banner.jpg"} ></img>
                                                </div>
                                            </div>
                                        }
                                        {/* {!this.state.loader && !this.state.isLoading && <EnglishCasinoHeader gameType={this.state.gameType} loader={this.state.loader} changeGameType={(type) => { this.changeGameType(type) }} gamePartner={this.state.gamePartner} changeGamePartner={(partner) => { this.changeGamePartner(partner) }} />} */}

                                        {!this.state.loader && !this.state.isLoading &&
                                            <>
                                                {/* {this.state.isLiveCasino ?
                                                    <>
                                                        <div className="row mt-4">
                                                            <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                                                                <div className="">
                                                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 mt-4 mb-2 featured-game1">
                                                                        <div className="row">
                                                                            {
                                                                                this.state.games.filter((gm, i) => { return gm.partner === "EZU" }).map((game) => (

                                                                                    <div className="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4" key={game.gameId} onClick={() => this.getIndividualGame(game.gameId)}>
                                                                                        <div className="img-pos">
                                                                                            <img alt="" src={` https://images.staticcontent.io/ecasino/${game.gameId}.jpg`} className="img-fluid" />
                                                                                            {
                                                                                                game.isNew &&
                                                                                                <div className="newgame"></div>
                                                                                            }
                                                                                            {
                                                                                                game.isPopular &&
                                                                                                <div className="hotgame"></div>
                                                                                            }
                                                                                        </div>
                                                                                        <div className="text-center game-title-main">{game.gameName}</div>
                                                                                    </div>

                                                                                ))
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                                                                <div className="">

                                                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 mt-4 mb-2 featured-game1">
                                                                        <div className="row">
                                                                            {
                                                                                this.state.games.filter((gm, i) => { return gm.partner === "BTV" }).map((game) => (
                                                                                    <div className="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4" key={game.gameId} onClick={() => this.getIndividualGame(game.gameId)}>
                                                                                        <div className="img-pos">
                                                                                            <img alt="" src={` https://images.staticcontent.io/ecasino/${game.gameId}.jpg`} className="img-fluid" />
                                                                                            {
                                                                                                game.isNew &&
                                                                                                <div className="newgame"></div>
                                                                                            }
                                                                                            {
                                                                                                game.isPopular &&
                                                                                                <div className="hotgame"></div>
                                                                                            }
                                                                                        </div>
                                                                                        <div className="text-center game-title-main">{game.gameName}</div>
                                                                                    </div>
                                                                                ))
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </> : */}
                                                <div className="row mt-4 mb-2 featured-game1">
                                                    {/* Lotus Aviator with static ID starts*/}
                                                    {/* <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2" key={'70016'} onClick={() => this.getIndividualGame(70016)}>
                                                        <div className="img-pos">
                                                            <img alt="" src={BASE_IMAGE_PATH + `/casino/img/royalcasino/aviator.jpg`} className="img-fluid" />
                                                            {/* {
                                                                game.isNew &&
                                                                <div className="newgame"></div>
                                                            }
                                                            {
                                                                game.isPopular &&
                                                                <div className="hotgame"></div>
                                                            } *}
                                                        </div>
                                                        <div className="text-center game-title-main">Aviator</div>
                                                    </div> */}
                                                    {/* Lotus Aviator with static ID ends*/}

                                                    {
                                                        !!this.state.games && this.state.games.length > 0 && this.state.games.map((game) => (
                                                            <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2" key={game.gameId} onClick={() => this.getIndividualGame(game.gameId)}>
                                                                <div className="img-pos">
                                                                    <img alt="" src={BASE_IMAGE_PATH + `/casino/img/royalcasino/${game.gameId}.jpg`} className="img-fluid" />
                                                                    {
                                                                        game.isNew &&
                                                                        <div className="newgame"></div>
                                                                    }
                                                                    {
                                                                        game.isPopular &&
                                                                        <div className="hotgame"></div>
                                                                    }
                                                                </div>
                                                                <div className="text-center game-title-main">{game.gameName}</div>
                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                                {/* } */}
                                            </>
                                        }
                                    </> :
                                        <div className="row">
                                            <div onClick={() => { this.setState({ openGame: false, isLoading: false }) }} style={{ position: "absolute", width: "30px", textAlign: "center" }}><i className="fa fa-times popup-cross"></i></div>
                                            <iframe title={"iframe"} key={"iframe"} style={{ height: "84vh", width: "100%", border: "0px" }} src={this.state.link}></iframe>
                                        </div>
                                    }
                                </div>
                            </section>

                        </div>
                    :
                        <>
                            {/* <!-- ====== STATIC IMAGES START ===== --> */}
                            <div className="col-center1 markets">
                                <section>
                                    <div className="sub_path center-box"><p>Spribe</p></div>
                                    <div className="container-fluid casino-content-page RDE">
                                        <div className="row mt-4 mb-2 featured-game1">
                                            <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 mb-2  livecasino-item slots__item" onClick={() => {if(!!profData && profData.role === 'DemoClient') {this.props.notify("Login with real Id.", "error")} else {authUtil.clickOpenLoginPopup()}}}>
                                                <div className="img-pos">
                                                    <img alt="" src="https://images.staticcontent.io/casino/without-login/aviator/201206.sbe_aviator.jpg" className="img-fluid" />
                                                </div>
                                                <div className="slots__bg-login">
                                                    <div className="slots__overlay">
                                                        <div className="slots__favorite">
                                                        </div>
                                                        <a href="javascript:void(0)" className="slots__btn-login">Play</a>
                                                    </div>
                                                </div>
                                                {/* <div className="text-center game-title-main">7 Up Down</div> */}
                                            </div>
                                            <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 mb-2  livecasino-item slots__item" onClick={() => {if(!!profData && profData.role === 'DemoClient') {this.props.notify("Login with real Id.", "error")} else {authUtil.clickOpenLoginPopup()}}}>
                                                <div className="img-pos">
                                                    <img alt="" src="https://images.staticcontent.io/casino/without-login/aviator/201203.sbe_keno.jpg" className="img-fluid" />
                                                </div>
                                                <div className="slots__bg-login">
                                                    <div className="slots__overlay">
                                                        <div className="slots__favorite">
                                                        </div>
                                                        <a href="javascript:void(0)" className="slots__btn-login">Play</a>
                                                    </div>
                                                </div>
                                                {/* <div className="text-center game-title-main">Auto Roulette</div> */}
                                            </div>
                                            <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 mb-2 livecasino-item slots__item" onClick={() => {if(!!profData && profData.role === 'DemoClient') {this.props.notify("Login with real Id.", "error")} else {authUtil.clickOpenLoginPopup()}}}>
                                                <div className="img-pos">
                                                    <img alt="" src="https://images.staticcontent.io/casino/without-login/aviator/201204.sbe_roulette.jpg" className="img-fluid" />
                                                </div>
                                                <div className="slots__bg-login">
                                                    <div className="slots__overlay">
                                                        <div className="slots__favorite">
                                                        </div>
                                                        <a href="javascript:void(0)" className="slots__btn-login">Play</a>
                                                    </div>
                                                </div>
                                                {/* <div className="text-center game-title-main">Teen Patti</div> */}
                                            </div>
                                            <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 mb-2 livecasino-item slots__item" onClick={() => {if(!!profData && profData.role === 'DemoClient') {this.props.notify("Login with real Id.", "error")} else {authUtil.clickOpenLoginPopup()}}}>
                                                <div className="img-pos">
                                                    <img alt="" src="https://images.staticcontent.io/casino/without-login/aviator/201205.sbe_hilo.jpg" className="img-fluid" />
                                                </div>
                                                <div className="slots__bg-login">
                                                    <div className="slots__overlay">
                                                        <div className="slots__favorite">
                                                        </div>
                                                        <a href="javascript:void(0)" className="slots__btn-login">Play</a>
                                                    </div>
                                                </div>
                                                {/* <div className="text-center game-title-main">Dragon Tiger</div> */}
                                            </div>
                                            <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 mb-2 livecasino-item slots__item" onClick={() => {if(!!profData && profData.role === 'DemoClient') {this.props.notify("Login with real Id.", "error")} else {authUtil.clickOpenLoginPopup()}}}>
                                                <div className="img-pos">
                                                    <img alt="" src="https://images.staticcontent.io/casino/without-login/aviator/201207.sbe_dice.jpg" className="img-fluid" />
                                                </div>
                                                <div className="slots__bg-login">
                                                    <div className="slots__overlay">
                                                        <div className="slots__favorite">
                                                        </div>
                                                        <a href="javascript:void(0)" className="slots__btn-login">Play</a>
                                                    </div>
                                                </div>
                                                {/* <div className="text-center game-title-main">Cricket War</div> */}
                                            </div>
                                            <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 mb-2 livecasino-item slots__item" onClick={() => {if(!!profData && profData.role === 'DemoClient') {this.props.notify("Login with real Id.", "error")} else {authUtil.clickOpenLoginPopup()}}}>
                                                <div className="img-pos">
                                                    <img alt="" src="https://images.staticcontent.io/casino/without-login/aviator/201208.sbe_mines.jpg" className="img-fluid" />
                                                </div>
                                                <div className="slots__bg-login">
                                                    <div className="slots__overlay">
                                                        <div className="slots__favorite">
                                                        </div>
                                                        <a href="javascript:void(0)" className="slots__btn-login">Play</a>
                                                    </div>
                                                </div>
                                                {/* <div className="text-center game-title-main">Amar Akbar Anthony</div> */}
                                            </div>
                                            <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 mb-2 livecasino-item slots__item" onClick={() => {if(!!profData && profData.role === 'DemoClient') {this.props.notify("Login with real Id.", "error")} else {authUtil.clickOpenLoginPopup()}}}>
                                                <div className="img-pos">
                                                    <img alt="" src="https://images.staticcontent.io/casino/without-login/aviator/201209.sbe_plinko.jpg" className="img-fluid" />
                                                </div>
                                                <div className="slots__bg-login">
                                                    <div className="slots__overlay">
                                                        <div className="slots__favorite">
                                                        </div>
                                                        <a href="javascript:void(0)" className="slots__btn-login">Play</a>
                                                    </div>
                                                </div>
                                                {/* <div className="text-center game-title-main">3 Cards Judgement</div> */}
                                            </div>
                                            <div className="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-2 mb-2 livecasino-item slots__item" onClick={() => {if(!!profData && profData.role === 'DemoClient') {this.props.notify("Login with real Id.", "error")} else {authUtil.clickOpenLoginPopup()}}}>
                                                <div className="img-pos">
                                                    <img alt="" src="https://images.staticcontent.io/casino/without-login/aviator/201210.sbe_goal.jpg" className="img-fluid" />
                                                </div>
                                                <div className="slots__bg-login">
                                                    <div className="slots__overlay">
                                                        <div className="slots__favorite">
                                                        </div>
                                                        <a href="javascript:void(0)" className="slots__btn-login">Play</a>
                                                    </div>
                                                </div>
                                                {/* <div className="text-center game-title-main">Poker VR</div> */}
                                            </div>
                                        </div>
                                    </div>
                                </section>

                            </div>
                            {/* <!-- ===== STATIC IMAGES END ===== --> */}
                        </>
                    }



        
                    {this.state.showPopup &&  (!!accData && Object.keys(accData).length > 0) && <>
                        <CasinoCurrencyModal currencyEquals={casinoCurrencyList["SPRIBE"].currencyEquals} fileNM={"casinopoint"} hidePopup={() => { this.hideCurrencyPopup() }} />
                        {/* <div id="marketbetspopup" className="modal fade show" style={{ display: "block" }} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-modal="true">
                            <div className="modal-dialog modal-sm modal-dialog-centered encasino">
                                <div className="modal-content">
                                    {/* <div className="modal-header">
                                        <h5 className="modal-title mt-0" id="myModalLabel">LIVE CASINO INFO</h5><button onClick={() => { this.setState({ showPopup: false }) }} type="button" className="close" data-dismiss="modal" aria-hidden="true">×</button>
                                    </div> *}
                                    <div className="modal-body engcasinomodalbgimg">

                                        <button onClick={() => { this.setState({ showPopup: false }) }} type="button" className="close text-white ecasinobtnclose" data-dismiss="modal" aria-hidden="true">×</button>
                                        <img alt="" src={`${BASE_IMAGE_PATH}/casino/banner/images/new-popup.png`} className="img-fluid" />
                                        <button type="button" className='virtual-close-btn' onClick={() => { this.setState({ showPopup: false }) }} data-dismiss="modal">&nbsp;</button>

                                    </div>
                                    {/* <div className="modal-footer">
                                        <button type="button" onClick={() => { this.setState({ showPopup: false }) }} className="btn btn-danger waves-effect mx-auto" data-dismiss="modal">Continue</button>
                                    </div> *}
                                </div>
                            </div>
                            <div className="modal-backdrop fade show" onClick={() => { }}></div>
                        </div> */}
                    </>}

                </div>
            </body>
        )
    }
}
function mapStateToProps(state) {
    return {
    };
}
function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(Spribe);